import Vue from "vue";
import Vuex from "vuex";
import VueCookie from 'vue-cookie'
import ApiCaller from '../utils/apicaller'
import types from './types'

Vue.use(Vuex);
Vue.use(VueCookie);

export default new Vuex.Store({
    state: {
        withQRheader: true,
        withQRfooter: true,
        titleHeader: '',
        sendButton: true,
        TitleFooter: '',
        business: [],
        feeds: [],
        history: [],
        category: [],
        follower: [],
        addBusiness: [],
        businessDetail: [],
        addCheckIn: [],
        addCategory: [],
        addRating: [],
        addFollower: [],
        addLike: [],
        userProfile: {},
        edisBusiness: {},
        popupClose: true

    },
    mutations: {
        [types.WITHQRHEADER]: (state, payload) => {
            state.withQRheader = payload
        },
        [types.WITHQRFOOTER]: (state, payload) => {
            state.withQRfooter = payload
        },
        [types.TITLEHEADER]: (state, payload) => {
            state.titleHeader = payload
        },
        [types.SENDBUTTON]: (state, payload) => {
            state.sendButton = payload
        },
        [types.TITLEFOOTER]: (state, payload) => {
            state.titleFooter = payload
        },
        [types.LOADBUSINESS]: (state, payload) => {
            if (payload.length === 0) {
                state.business = []
            } else {
                state.business.push(...payload)

            }
        },
        [types.LOADBUSINESSDETAIL]: (state, payload) => {
            state.businessDetail = payload
        },
        [types.LOADFEEDS]: (state, payload) => {
            if (payload.length === 0) {
                state.feeds = []
            } else {
                state.feeds.push(...payload)
            }
        },
        setShareCount: (state, payload) => {
            console.log("SHARE COUNT FROM STORE", payload);
            const targetfeed = state.feeds.filter(feed => feed.id == payload.id)[0];
            targetfeed.shares = payload.count;
        },
        storeBusinessdetail: (state, payload) => {
            state.edisBusiness = payload
        },
        AddComments: (state, payload) => {
            console.log("FROM COMMENT STORE payload", payload);
            const targetfeed = state.feeds.filter(feed => feed.id == payload.id)[0];
            targetfeed.comments.push(payload.commentdetails)
            console.log("FROM COMMENT STORE", targetfeed);
        },
        LoadProfile: (state, payload) => {
            state.userProfile = payload
        },
        closePopUp: (state, payload) => {
            state.popupClose = payload
        },
        [types.LOADCATEGORY]: (state, payload) => {
            state.category = payload
        },
        [types.LOADUSERHISTORY]: (state, payload) => {
            if (payload.length === 0) {
                state.history = []
            } else {
                state.history.push(...payload)
            }
        },
        [types.LOADFOLLOWER]: (state, payload) => {
            state.follower = payload
        },
        [types.ADDBUSINESS]: (state, payload) => {
            state.addBusiness = payload
        },
        [types.ADDRATING]: (state, payload) => {
            state.addRating = payload
        },
        [types.ADDFOLLOWER]: (state, payload) => {
            state.addFollower = payload
        },
        [types.ADDLIKES]: (state, payload) => {
            state.addLike = payload
        },
        doLike: (state, payload) => {
            const targetfeed = state.feeds.filter(feed => feed.id == payload.id)[0];
            targetfeed.liked_by_user = true;
            targetfeed.likes.push(payload.likedetails)
            console.log("FROM LIKE STORE", targetfeed);

        }
    },
    actions: {
        async getBusiness({ commit }, { type, payload }) {
            let business = await ApiCaller(`/business?lat=${VueCookie.get('latitude')}&long=${VueCookie.get('longitude')}&limit=0`, 'get')
            commit(types.LOADBUSINESS, business)
        },
        async getBusinessDetail({ commit }, { type, payload }) {
            let businessDetail = await ApiCaller(`/business/${payload}?lat=${VueCookie.get('latitude')}&long=${VueCookie.get('longitude')}`, 'get')
            return businessDetail
        },

        async getFeeds({ commit }, { type, payload }) {
            let feeds = await ApiCaller(`/feed?lat=${VueCookie.get('latitude')}&long=${VueCookie.get('longitude')}&limit=0`, 'get')
            commit(types.LOADFEEDS, feeds)
        },

        // async getUserHistory({ commit }, { type, payload }) {
        //     let history = await ApiCaller(`/feed/history?limit=0`, 'get')
        //     commit(types.LOADUSERHISTORY, history)
        // },

        async getCategory({ commit }, { type, payload }) {
            let category = await ApiCaller('/business/category/', 'get')
            commit(types.LOADCATEGORY, category)
        },

        async getFollower({ commit }, { type, payload }) {
            let follower = await ApiCaller('/business/followerlist/' + payload, 'get')
            return follower;
        },

        async postBusiness({ commit }, { type, payload }) {
            let addBusiness = await ApiCaller('/business/create', 'post', payload)
            return addBusiness;
        },

        postCheckIn({ commit }, { type, payload }) {
            let addCheckIn = ApiCaller('/feed/create', 'post', payload)
            console.log(payload)
            return addCheckIn;
        },

        async postCategory({ commit }, { type, payload }) {
            let addCategory = await ApiCaller('/business/category/create', 'post', payload)
            return addCategory;
        },

        async postRating({ commit }, { type, payload }) {
            let addrating = await ApiCaller('/business/rating/', 'post', payload)
            return addrating;
        },

        postLike({ commit }, { type, payload }) {
            let postLike = ApiCaller('/feed/like', 'post', payload)
            return postLike;
        },

        postFollower({ commit }, { type, payload }) {
            let addFollower = ApiCaller('/business/addfollower/', 'post', payload)
            return addFollower;
        },
        getUserProfile({ commit }, { type, payload }) {
            let userProfile = ApiCaller(`/feed/profile?lat=${VueCookie.get('latitude')}&long=${VueCookie.get('longitude')}`, 'get')
            return userProfile;
            // commit(types.LOADPROFILEFEEDS, userProfile)
        },
        postCmnt({ commit }, { type, payload }) {
            let postCmnt = ApiCaller('/feed/save_comment', 'post', payload)
            return postCmnt;
        },
        shareApp({ commit }, { type, payload }) {
            let shareApp = ApiCaller('/feed/share', 'post', payload)
            return shareApp;
        },
        // getNotifications({ commit }, { type, payload }) {
        //     let getNotifications = ApiCaller('/feed/notification', 'get')
        //     return getNotifications;
        // },
        getNearByFeeds({ commit }, { type, payload }) {
            let getNearByFeeds = ApiCaller(`/feed/nearbyfeed?lat=${VueCookie.get('latitude')}&long=${VueCookie.get('longitude')}&limit=0`, 'get')
            return getNearByFeeds;
        },
        async getNotifications({ commit }, { type, payload }) {
            let history = await ApiCaller(`/feed/notification?limit=0`, 'get')
            commit(types.LOADUSERHISTORY, history)
        },


    }
});